import React, { useMemo, useState } from "react";
import CustomModal from "../../../shared/CustomModal";
import Select from "../../../shared/Select";
import Button from "../../../shared/Button";

const CopyClassroomConfigModal = ({
  classroomOptions,
  copyConfigModal,
  yearLevelConfig,
  copyConfig,
  setCopyConfigModal,
  assessmentSubjectConfigurations,
  assessmentGeneralConfigurations,
  setAssessmentSubjectConfigurations,
  setAssessmentGeneralConfigurations,
}) => {
  const [options, setOptions] = useState(null);

  const modalHeader = useMemo(() => {
    const yearLevel = yearLevelConfig[copyConfig?.yearLevelId];
    const selectedClassroom = yearLevel?.classrooms?.find(
      (item) => item.id === copyConfig?.fromClassroomId,
    );
    return selectedClassroom
      ? `Apply config of ${selectedClassroom.name}`
      : "Apply config";
  }, [yearLevelConfig, copyConfig?.yearLevelId, copyConfig?.fromClassroomId]);

  //copy section config handler
  const handleCopySectionConfig = () => {
    if (!options?.length) return;

    const { yearLevelId, fromClassroomId } = copyConfig;

    const classroomIds = options.map((item) => item.value);

    const fromSectionSubjectAssessment =
      assessmentSubjectConfigurations?.filter(
        (item) =>
          item.yearLevelId === yearLevelId &&
          item.classroomId === fromClassroomId,
      ) ?? [];

    const copiedSubjectConfigs = classroomIds.flatMap((classroomId) =>
      fromSectionSubjectAssessment.map((item) => ({
        ...item,
        isRecorded: false,
        classroomId,
      })),
    );

    setAssessmentSubjectConfigurations((prev) => {
      const filtered = prev.filter(
        (item) =>
          !copiedSubjectConfigs.some(
            (copy) =>
              copy.yearLevelId === item.yearLevelId &&
              copy.classroomId === item.classroomId,
          ),
      );

      return [...filtered, ...copiedSubjectConfigs];
    });

    const fromSectionGeneralAssessment =
      assessmentGeneralConfigurations?.filter(
        (item) =>
          item.yearLevelId === yearLevelId &&
          item.classroomId === fromClassroomId,
      ) ?? [];

    const copiedGeneralConfigs = classroomIds.flatMap((classroomId) =>
      fromSectionGeneralAssessment.map((item) => ({
        ...item,
        isRecorded: false,
        classroomId,
      })),
    );

    setAssessmentGeneralConfigurations((prev) => {
      const filtered = prev.filter(
        (item) =>
          !copiedGeneralConfigs.some(
            (copy) =>
              copy.yearLevelId === item.yearLevelId &&
              copy.classroomId === item.classroomId,
          ),
      );

      return [...filtered, ...copiedGeneralConfigs];
    });

    setCopyConfigModal(false);
    setOptions(null);
  };

  return (
    <CustomModal
      isOpen={copyConfigModal}
      toggle={() => {
        setCopyConfigModal(false);
        setOptions(null);
      }}
      modalHeader={modalHeader}
      children={
        <div>
          <Select
            options={classroomOptions?.filter(
              (opt) => opt.value !== copyConfig?.fromClassroomId,
            )}
            isMulti={true}
            value={options}
            styles={{ control: { minWidth: "200px" } }}
            placeholder={"Select Section"}
            onChange={(selectedOptions) => setOptions(selectedOptions)}
          />

          <div style={{ marginTop: "16px" }} className="action-btns end">
            <Button size="sm" onClick={handleCopySectionConfig}>
              Apply
            </Button>
          </div>

          <div className="arr-note">
            <strong>Note: </strong>
            Copying configuration from one section to another will overwrite any
            existing configuration in the target section. Please proceed only if
            you intend to replace the current settings.
          </div>
        </div>
      }
    />
  );
};

export default CopyClassroomConfigModal;
